export default "/packs/6e564799e01e5b8045bc02bd32d4a053.svg";